import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const BackHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${tokens.space.md};
  margin-bottom: ${tokens.space.lg};
`

export const BackHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: ${tokens.space.sm};
  min-width: 0;
`

export const BackHeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: ${tokens.space.sm};
  flex-shrink: 0;
`

export const BackBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  flex-shrink: 0;
  border-radius: ${tokens.radius.control};
  border: 1px solid ${tokens.border.hairline};
  background: ${tokens.surface.glass};
  color: ${tokens.text.secondary};
  cursor: pointer;
  transition: background ${tokens.motion.duration} ${tokens.motion.ease},
    color ${tokens.motion.duration} ${tokens.motion.ease};

  svg {
    width: 1rem;
    height: 1rem;
  }

  &:hover {
    background: ${tokens.surface.inset};
    color: ${tokens.text.primary};
  }

  &:focus-visible {
    outline: 2px solid ${tokens.accent.base};
    outline-offset: 2px;
  }
`
